import type { CompanyRelationshipType } from "../types";

type TranslateFn = (key: string, options?: { _: string }) => string;

export type CompanyRelationshipChoice = {
  value: CompanyRelationshipType;
  label: string;
  fallback: string;
};

export const companyRelationshipChoices: CompanyRelationshipChoice[] = [
  {
    value: "partner-roofer",
    label: "resources.companies.relationship_types.partner_roofer",
    fallback: "Partner Roofer",
  },
  {
    value: "referral-partner",
    label: "resources.companies.relationship_types.referral_partner",
    fallback: "Referral Partner",
  },
  {
    value: "other",
    label: "resources.companies.relationship_types.other",
    fallback: "Other",
  },
];

export const getCompanyRelationshipChoice = (
  value: CompanyRelationshipType | null | undefined,
) =>
  companyRelationshipChoices.find((choice) => choice.value === value) ??
  companyRelationshipChoices.find((choice) => choice.value === "other")!;

export const getCompanyRelationshipLabel = (
  translate: TranslateFn,
  value: CompanyRelationshipType | null | undefined,
) => {
  const choice = getCompanyRelationshipChoice(value);
  return translate(choice.label, { _: choice.fallback });
};
